import { Button, Card, Form, Input, message, Spin, Typography } from "antd";
import { useState } from "react";
import api from "../../api/axios";

const { Title, Text } = Typography;

export default function ResellerBalance() {
  const [balance, setBalance] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [form] = Form.useForm();

  const fetchBalance = async (password: string) => {
    setLoading(true);
    try {
      const response = await api.get('/pos/Resellers/getBalance', { params : {password} });
      setBalance(response.data);
      setAuthenticated(true);
    } catch (error) {
      message.error('Failed to load balance. Please check your password.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (values: { password: string }) => {
    fetchBalance(values.password);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
      <Card
        bordered={false}
        style={{ width: 400, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: 12, textAlign: 'center' }}
      >
        <Title level={3} style={{ marginBottom: 16 }}>Account Balance</Title>
        
        {!authenticated ? (
          <Form form={form} onFinish={handleSubmit} layout="vertical" style={{ maxWidth: 300, margin: '0 auto' }}>
            <Form.Item
              name="password"
              label="Enter Balance Password"
              rules={[{ required: true, message: 'Please enter your balance password' }]}
            >
              <Input.Password placeholder="Enter password" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%' }}>
                View Balance
              </Button>
            </Form.Item>
          </Form>
        ) : loading ? (
          <Spin />
        ) : (
          <Text style={{ fontSize: 28, color: '#52c41a', fontWeight: 'bold', display: 'block', marginTop: 16 }}>
            {balance?.toFixed(2)}
          </Text>
        )}
      </Card>
    </div>
  );
}
